import React from "react";
import "./brandList.css";

const BrandList = ({ brands, selectedBrandId, onBrandClick, isLoading }) => {
  const handleClick = (brand) => {
    if (!isLoading) {
      onBrandClick?.(brand);
    }
  };

  const getBrandDisplayValue = (brand) => {
    return brand?.id || "";
  };

  return (
    <div className="brandBlock">
      <h3>Brands</h3>

      {isLoading ? (
        <div className="brand-loading">Loading models...</div>
      ) : brands.length === 0 ? (
        <p>No brands to display.</p>
      ) : (
        <ul className="brand-list">
          {brands.map((brand, index) => (
            <li
              key={brand.id}
              className={`brand-row ${index % 2 === 0 ? "even" : "odd"} ${
                selectedBrandId === brand.id ? "selected" : ""
              }`}
              onClick={() => handleClick(brand)}
              style={{
                cursor: isLoading ? "not-allowed" : "pointer",
                opacity: isLoading ? 0.6 : 1,
              }}
            >
              {getBrandDisplayValue(brand)}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default BrandList;
